// extracted by mini-css-extract-plugin
export default {"statusPnl":"style_statusPnl__+syjp","statusBox":"style_statusBox__o+c7c","statusText":"style_statusText__x0Gh0"};